import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { TipologiasInterface } from 'app/models/tipologias.model';
import { ResponseTiposGestionesBienesCulturales } from './models/gestiones-bienes-culturales';
import { GenerarDocuentoInterface } from './models/generar-documento.model';
import { DocumentoGenerado, DocumentosGeneradosResponse } from './models/response-documento-generado';
import { BehaviorSubject } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environments';
import { PlantillasResponse } from 'app/modules/admin/documentos-oficiales/models/plantillas.model';

@Injectable({providedIn: 'root'})
export class DocumentosEmitidosService {
    documentosEmitidosList = new BehaviorSubject<DocumentoGenerado[]>([]);

    get documentosEmitidosList$(){
        return this.documentosEmitidosList.asObservable();
    }

    constructor(
        private apiService:ApiService,
        private sanitizer: DomSanitizer,
        private http: HttpClient,
    ) { }

    getTipologiaDocumentosEmitidos(tipologia:number){
        const url= `/tipologias/${tipologia}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener tipo de documentos.')
                .subscribe((response:TipologiasInterface) => {
                    resolve(response[0].tipologias)  
                }, error => {
                    reject(error)
                })
        })
    }

    //*** Se filtran en backend por el id del usuario. */
    getGestionesByBienesCulturales(){
        const url= `/gestion/bienes_culturales` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener tipo de gestiones.')
                .subscribe((response:ResponseTiposGestionesBienesCulturales) => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    postDocumento(data: GenerarDocuentoInterface){
        const url= `/documento_generado` 
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, data, {}, 'Error al emitir documento.')
                .subscribe((response:ResponseTiposGestionesBienesCulturales) => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    getDocumentosGenerados(uu_id:string){
        const params= {bienCulturalUuid:uu_id}
        const url= `/documento_generado` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener documentos emitidos.')
                .subscribe((response:DocumentosGeneradosResponse) => {
                    this.documentosEmitidosList.next(response.data)
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }
    
    getDocumentoBlob(documentId: string): Promise<Blob> {
        const url = `${environment.API_SERVER_URL}/api/documento_generado/obtener/${documentId}`;
        return new Promise((resolve, reject) => {
            this.http.get(url, { responseType: 'blob' }).subscribe(
                blob => resolve(blob),     
                error => reject(error)
            );;
        });
    }


    async obtenerDocumentoGenerado(documentId: string): Promise<SafeResourceUrl | null> {
        try {
            const blob = await this.getDocumentoBlob(documentId);
            const blobUrl = URL.createObjectURL(blob);
            const documenSanitizedURL = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
            return documenSanitizedURL;
        } catch (error) {
            console.error('Error al obtener documento generado:', error);
            return null;
        }
    }

    postFichaDeRegistro(data: GenerarDocuentoInterface){
        const url= `/ficha_registro/generar` 
        return new Promise((resolve, reject)=>{
            this.apiService.PostMethod(url, data, {}, 'Error al emitir documento.')
                .subscribe((response:ResponseTiposGestionesBienesCulturales) => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    deleteDocumentoGenerado(uuid_documento:string, bienCulturalUuid: string): Promise<void> {
        const url = `/documento_generado/${uuid_documento}`;
        const params = { bienCulturalUuid: bienCulturalUuid };
        return new Promise((resolve, reject) => {
            this.apiService.DeleteMethod(url, {}, 'Error al eliminar el documento emitido.')
                .subscribe(() => {
                    resolve();
                }, error => {
                    reject(error);
                });
        });
    }

    certificarDocumento(documentoUuid:string, bienCulturalUuid: string): Promise<void> {
        const url = `/documento_generado/certificar`;
        const body = { bienCulturalUuid: bienCulturalUuid, documentoUuid: documentoUuid};
        return new Promise((resolve, reject) => {
            this.apiService.PutMethod(url, body, {}, 'Error al certificar el documento emitido.')
                .subscribe(() => {
                    resolve();
                }, error => {
                    reject(error);
                });
        });
    }   

    getPlantillas(seccion_uuid:number){
        const params= {seccion: seccion_uuid}
        const url=`/plantillas` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener las plantillas.')
                .subscribe((response: PlantillasResponse) => {
                    resolve(response.data)                    
                }, error => {
                    reject(true)
                })
        })
    }


    
}